import { useLocation } from "react-router-dom";
import Chart from "./chart";
import { MdPublish } from "react-icons/md";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { userRequest } from "../../requestMethods";


const OrderListEdit = () => {
  
  const location = useLocation();
  const orderId = location.pathname.split("/")[2];
  const [oStats, setOStats] = useState([]);
  const [edit, setEdit] = useState({})

  const order = useSelector((state) =>
    state.order.orders.find((order) => order._id === orderId)
  );

  const MONTHS = useMemo(
    () => [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    []
  );

  useEffect(() => {
    const getStats = async () => {
      try {
        const res = await userRequest.get("orders/income?pid=" + orderId);
        const list = res.data.sort((a,b)=>{
            return a._id - b._id
        })
        list.map((item) =>
          setOStats((prev) => [
            ...prev,
            { name: MONTHS[item._id - 1], Sales: item.total },
          ])
        );
      } catch (err) {
        console.log(err);
      }
    };
    getStats();
  }, [orderId, MONTHS]);

  return (
    <div className="product">
      <div className="productTitleContainer">
        <h1 className="productTitle">Edit Orders</h1>
        {/* <Link to="/newproduct">
          <button className="btn btn-outline-primary">Create</button>
        </Link> */}
      </div>
      <div className="productTop">
        <div className="productTopLeft">
          <Chart data={oStats} dataKey="Sales" title="Sales Performance" />
        </div>
        <div className="productTopRight">
          <div className="productInfoTop">
            <img src={order.img} alt="" className="productInfoImg" />
            <span className="productName">{order.title}</span>
          </div>
          <div className="productInfoBottom">
            <div className="productInfoItem">
              <span className="productInfoKey">id: </span>
              <span className="productInfoValue"> { order._id}</span>
            </div>
            <div className="productInfoItem">
              <span className="productInfoKey">sales:</span>
              <span className="productInfoValue">5123</span>
            </div>
            <div className="productInfoItem">
              <span className="productInfoKey">in stock:</span>
              <span className="productInfoValue">{order.inStock}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="productBottom">
        <form className="productForm">
          <div className="productFormLeft">
            <label>Product Name</label>
            <input type="text" placeholder={order.title} />
            <label>Product Description</label>
            <input type="text" placeholder={order.desc} />
            <label>Price</label>
            <input type="text" placeholder={order.price} />
            <label>In Stock</label>
            <select name="inStock" id="idStock">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
          <div className="productFormRight">
            <div className="productUpload">
              <img src={order.img} alt="" className="productUploadImg" />
              <label for="file">
                <MdPublish />
              </label>
              <input type="file" id="file" style={{ display: "none" }} />
            </div>
            <button className="btn btn-outline-danger">Update</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default OrderListEdit;
